import { fetchApi } from "../../tools"

export const reportes = async (url, headers, objeto) => {
    const data = await fetchApi({
        url: `${url}/reportes/asistencia`,
        headers: headers,
        content: objeto,
      });
      return data;
}
